import React from 'react';
import { Route, Switch } from 'react-router';
import { POS_ROUTES } from 'PointOfSale/modules/common/constants';
import QueueSideBar from 'PointOfSale/modules/queue/component/QueueSideBar';
import CepSideBar from 'PointOfSale/modules/cepCard/component/CepSideBar';
import ProfileCardContainer from 'PointOfSale/modules/individualServing/container/ProfileCardContainer';
import GroupSideBarContainer from 'PointOfSale/modules/group/container/GroupSideBarContainer';
import TeacherSideBarContainer from 'PointOfSale/modules/teacher/container/TeacherSideBarContainer';
import MealsTypesSideBar from 'PointOfSale/modules/layouts/container/pageSidebar/MealsTypesSideBar';

import 'PointOfSale/styles/components/posSideBar.less';

const PosSideBar = props => (
  <div
    className="side-bar-container justify-between flex-min-height-bug-fix"
    id={'side-bar-container'}
  >
    <Switch>
      <Route path={POS_ROUTES.MEAL_COUNTER} component={CepSideBar} />

      <Route
        path={POS_ROUTES.QUEUE_INDIVIDUAL}
        component={ProfileCardContainer}
      />
      <Route path={POS_ROUTES.QUEUE} component={QueueSideBar} />
      <Route
        path={POS_ROUTES.GROUP_INDIVIDUAL}
        component={ProfileCardContainer}
      />
      <Route path={POS_ROUTES.GROUP} component={GroupSideBarContainer} />
      <Route
        path={POS_ROUTES.TEACHER_INDIVIDUAL}
        component={ProfileCardContainer}
      />
      <Route path={POS_ROUTES.TEACHER} component={TeacherSideBarContainer} />
      <Route path={POS_ROUTES.HOME} component={MealsTypesSideBar} />
    </Switch>
  </div>
);

export default PosSideBar;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/layouts/component/pageSidebar/SideBar.js